









































































import { computed, defineComponent, PropType, ref, useContext } from '@nuxtjs/composition-api'
import DHorizontalScroll from '~/components/molecules/DS2/DHorizontalScroll'
import Gallery from '~/components/molecules/Gallery'
import { ServiceMovie } from '~/stub/apigateway/service/service_pb'

const ServiceDetailImagesSp = defineComponent({
  name: 'ServiceDetailImagesSp',
  components: {
    Vuetube: () => import('~/components/molecules/Vuetube' /* webpackChunkName: "Vuetube" */),
    Gallery,
    DHorizontalScroll,
    DLazyImage: () =>
      import('~/components/atoms/DS2/DLazyImage' /* webpackChunkName: "DLazyImage" */)
  },
  props: {
    serviceName: {
      type: String,
      default: ''
    },
    serviceImageList: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    serviceMovieList: {
      type: Array as PropType<ServiceMovie.AsObject[]>,
      default: () => []
    },
    moviePriorityFlag: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  setup(props) {
    const { $coconala } = useContext()

    /** ギャラリーコンポーネント */
    const gallery = ref<InstanceType<typeof Gallery>>()

    /** Vuetubeの活性状態 */
    const isVideoActive = ref(false)

    /** ギャラリーに表示する画像URLリスト */
    const galleryItemList = computed(() => {
      return props.serviceImageList.map(v => ({
        src: $coconala.serviceImageURLV2(v, 1220, 1240, 'box')
      }))
    })

    /** ギャラリー表示処理 */
    const openGallery = (imageIndex: number) => {
      if (!gallery.value) return
      const option = {
        bgOpacity: 0.7,
        tapToClose: true
      }
      gallery.value.open(imageIndex, option)
    }

    return {
      gallery,
      isVideoActive,
      galleryItemList,
      openGallery
    }
  }
})
export default ServiceDetailImagesSp
